module.exports = __webpack_public_path__ + "static/img/empty.d8da82f2.png";